import '../assets/styles/Listes.css';

/**
 * Panneau d'aperçu d'un document : le PDF lui-même dans un cadre, et les
 * actions en haut.
 *
 * Même parti pris que le panneau du contrat : on ne montre pas une seconde
 * mise en page du document, mais le document tel qu'il partira. Ce qui a
 * besoin d'un autre corps — l'émargement d'une feuille, par exemple — le
 * passe en `children` et remplace alors l'aperçu.
 */
function PanneauApercu({ titre, sousTitre, url, actions, children, onClose }) {
  return (
    <div className="devis-modal-overlay apercu-overlay" onClick={onClose}>
      <div className="devis-modal apercu-modal" onClick={(e) => e.stopPropagation()}>
        <div className="devis-modal-header">
          <div className="apercu-identite">
            <div className="devis-modal-numero">{titre}</div>
            {sousTitre && <div className="devis-modal-sub">{sousTitre}</div>}
          </div>
          <div className="devis-modal-header-right apercu-actions">
            {actions}
            <button
              type="button"
              className="devis-drawer-close"
              onClick={onClose}
              aria-label="Fermer"
            >
              ×
            </button>
          </div>
        </div>

        {children || (
          <div className="apercu-cadre">
            {/* key sur l'URL : régénérer le document change le paramètre, et
                le cadre recharge au lieu de garder la version d'avant. */}
            <iframe key={url} title={titre} src={url} />
          </div>
        )}
      </div>
    </div>
  );
}

export default PanneauApercu;
